const production = 1;

export const API_URL = !production ? process.env.REACT_APP_LOCAL_API : process.env.REACT_APP_PROD_API;